import { ug } from "../../../../date-fns/locale/ug.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ug
  }
};